(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-aar-popup-holidays"] && !window.DesignMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById("holiday-popup");
    const closePopupButton = document.getElementById("close-popup-btn");
    const closeIcon = document.querySelector(".close-popup");

    // Show the popup
    popup.style.display = "block";

    // Close popup on button click
    closePopupButton.addEventListener("click", function () {
      popup.style.display = "none";
    });

    // Close popup on close icon click
    closeIcon.addEventListener("click", function () {
      popup.style.display = "none";
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-aar-popup-scrubber"] && !window.DesignMode) return;
  try {
    
    var lang = "{{ lang }}"; 
    // Function to set a cookie
    function setCookie(name, value, hours) {
      var date = new Date();
      date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
      var expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
  
    // Function to get a cookie value by name
    function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
    
    // Function to close the message popup 
    function closeMessagePopup() {
        document.getElementById('message-popup').style.display = 'none';
    }
    
     // Function to get URL parameter value
     function getUrlParameter(name) {
      var params = new URLSearchParams(window.location.search);
      return params.get(name);
    }
   
    document.addEventListener('DOMContentLoaded', function() {
      
     // Check if the popup has been shown in the last 2 hours
     var hasSeenPopup = getCookie("hasSeenPopup");

      if (!hasSeenPopup) {
        // Show the popup
        document.getElementById('popup-form').style.display = 'flex';
        // Set a cookie that lasts for 2 hours
        setCookie("hasSeenPopup", "true", 2);
      }

      // Check for contact_posted parameter in the URL
      var contactPosted = getUrlParameter('contact_posted');
      if (contactPosted === 'true') {
         // Success case
            document.getElementById('message-popup').classList.add('success');
            document.getElementById('message-icon').innerHTML = '&#10003;'; // Green checkmark
            document.getElementById('message-text').textContent = (lang === 'en') ? 'Thank you! Your message has been successfully sent.' : 'Merci ! Votre message a été envoyé avec succès.';
            document.getElementById('message-popup').style.display = 'block';
        } 
        else if (contactPosted !== null) {
         // Error case
            document.getElementById('message-popup').classList.add('error');
            document.getElementById('message-icon').innerHTML = '&#10060;'; // Red cross
            document.getElementById('message-text').textContent = (lang === 'en') ? 'There was an error sending your message. Please try again.' : 'Une erreur s\'est produite lors de l\'envoi de votre message. Veuillez réessayer.';
            document.getElementById('message-popup').style.display = 'block';
        }
    
      // Open popup with button
      document.getElementById('open-popup').addEventListener('click', function() {
      document.getElementById('popup-form').style.display = 'flex';
      })
      // Close popup when the close button is clicked
      document.querySelector('.close-popup').addEventListener('click', function() {
        document.getElementById('popup-form').style.display = 'none';
      });

      // Close message popup when the close button is clicked
      document.querySelector('.close-message-popup').addEventListener('click', function() {
        document.getElementById('message-popup').style.display = 'none';
      });
    
      // Optional: Close popup when clicking outside the form content
      document.getElementById('popup-form').addEventListener('click', function(event) {
        if (event.target === this) {
          document.getElementById('popup-form').style.display = 'none';
        }
      });
    
    });

    
    
  
  
   
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
